"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScrollToMode;
(function (ScrollToMode) {
    /**
     * Does not make any consideration to where in the viewport the item should align to.
     */
    ScrollToMode[ScrollToMode["auto"] = 0] = "auto";
    /**
     * Attempts to scroll the list so the top of the desired item is aligned with the top of the viewport.
     */
    ScrollToMode[ScrollToMode["top"] = 1] = "top";
    /**
     * Attempts to scroll the list so the bottom of the desired item is aligned with the bottom of the viewport.
     */
    ScrollToMode[ScrollToMode["bottom"] = 2] = "bottom";
    /**
     * Attempts to scroll the list so the desired item is in the exact center of the viewport.
     */
    ScrollToMode[ScrollToMode["center"] = 3] = "center";
})(ScrollToMode = exports.ScrollToMode || (exports.ScrollToMode = {}));
//# sourceMappingURL=List.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/List/List.types.js
// module id = 1598
// module chunks = 0